const BoxCheckIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66675 10.8266L15.0001 15.3333M6.66675 10.8266V20.1601L15.0001 24.6668V15.3333M6.66675 10.8266L15.0001 6.66663L23.3334 10.8266M23.3334 10.8266V16.6666M23.3334 10.8266L15.0001 15.3333M26.0001 20C26.0001 20 23.4287 22.7857 22.1429 26L20.0001 23.4285"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default BoxCheckIcon
